import axios from "axios";
import ErrorException from '../utils/Exceptions.js';
import { setLocalAuth } from '../utils/AuthUtils.js';
import client from '../utils/ApiHelper.js';
import { baseUrl } from "../constants/Constant.js";

async function loginPost(username, password) {
    try {
        let user = await client.post("/sign-in", {
            username: username,
            password: password,
        });

        let userPrivilege = await axios({
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${user.data.data.token}`,
            },
            url: `${baseUrl}/control-list/privilege_id/${user.data.data.privilege_id}`,
        });

        await setLocalAuth(JSON.stringify(user.data), JSON.stringify(userPrivilege.data));
        return user.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export { loginPost };